import { useQuery } from '@tanstack/react-query';
import { referenceDataApi } from '../services/api';

export function useReferenceData() {
  return useQuery({
    queryKey: ['reference-data'],
    queryFn: () => referenceDataApi.get(),
    staleTime: Infinity, // données quasi-statiques
  });
}
